import { Helmet } from 'react-helmet';

import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { getNavUrl } from '../../utils/navigation';

export const PageParameter = () => {
  const history = useHistory()

  const onMoveClick = (e: React.MouseEvent) => {
    e.preventDefault()
    history.push(getNavUrl('/item/apple?utm_source=instagram&utm_medium=referral&utm_campaign=spring_sale&utm_term=apple&utm_content=apple'))
  }

  return (
    <>
      <Helmet>
        <title>맞춤 등록 가능한 매개변수 파악하기</title>
      </Helmet>
      <div>
        <Button onClick={(e) => onMoveClick(e) } size="large" type="primary">페이지 이동하기</Button>
      </div>
    </>
  )
}